<template>
  <JwlModal :controller="updateController">
    <h4 class="mt-0">New Version available</h4>
    <JwlButton @button-clicked="reload()">Reload</JwlButton>
  </JwlModal>
</template>

<script setup>
  const moduleStore = useModuleStore();
  const updateController = useModal();

  const checkVersion = async () => {
    const isSameVersion = await moduleStore.checkVersion();
    if (!isSameVersion) {
      updateController.open();
    }
  };

  const reload = () => {
    window.location.reload();
  };

  onMounted(() => {
    setInterval(checkVersion, 60000);
  });
</script>
